import { emptyArray } from 'ui-components/default-props/empty';
import { CommodityPresetSortColumn, OrderByDirection } from '@shipstation/client-common/types/freight-requests';

import type { CommodityPresetsState } from './ltl.commodity-presets.reducer';

export const selectCommodityPresetGridCurrentPageIds = (state: CommodityPresetsState) => state.currentPageCommodityPresetIds ?? emptyArray;

export const selectCommodityPresetGridPage = (state: CommodityPresetsState) => state.page ?? 1;

export const selectCommodityPresetGridPageSize = (state: CommodityPresetsState) => state.pageSize ?? 50;

export const selectCommodityPresetGridTotalCount = (state: CommodityPresetsState) => state.totalRecords ?? 0;

export const selectCommodityPresetGridIsLoading = (state: CommodityPresetsState) => state.isLoading ?? false;

export const selectCommodityPresetGridIsSaving = (state: CommodityPresetsState) => state.isSaving ?? false;

export const selectCommodityPresetGridIsSaveError = (state: CommodityPresetsState) => state.isSaveError ?? false;

export const selectCommodityPresetGridSearchTerm = (state: CommodityPresetsState) => state.searchTerm ?? '';

export const selectCommodityPresetGridOrderBy = (state: CommodityPresetsState) => state.orderBy ?? CommodityPresetSortColumn.Name;

export const selectCommodityPresetGridOrderByDirection = (state: CommodityPresetsState) =>
  state.orderByDirection ?? OrderByDirection.Ascending;

export const selectCommodityPresetGridSelectedIds = (state: CommodityPresetsState) => state.selectedCommodityPresetIds ?? emptyArray;
